mutation UploadDromoImportResults($input: DromoImportInput!) {
    dromoImport(input: $input) {
        success
    }
}
